import {useHistory} from 'react-router-dom';
import GruposCrud from "../../components/Crud/MainCrud/GruposCrud/GruposCrud";
import Exit from "../../components/Button/Exit/Exit";
import MenuBar from "../../components/Menu/MenuBar";
import Title from "../../components/Title/Title";
import { hasPermission } from "../../utils/utils";

import "./Grupos.css";

export default function Grupos() {
    
    const history = useHistory();
    
    if(!hasPermission('grupos')){
        history.push('/');
    }
    
    return (
        <div className='Grupos'>
            <MenuBar />
            <Title>Grupos</Title>
            <div className="Container">
                <div className="Content">
                    <div className="row">
                        <GruposCrud />
                    </div>
                    <div className="Row-exit">
                        <Exit />
                    </div>
                </div>
            </div>
        </div>
    )
};